import { useMutation } from "@tanstack/react-query";
import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { customFetch } from "./custom-fetch";
import type { ErrorType } from "./custom-fetch";

export const deleteEstimate = async (id: number): Promise<void> => {
  return customFetch<void>(`/api/estimates/${id}`, {
    method: "DELETE",
  });
};

export const useDeleteEstimate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<void, TError, { id: number }, TContext>;
}): UseMutationResult<void, TError, { id: number }, TContext> => {
  const { mutation: mutationOptions } = options ?? {};
  return useMutation<void, TError, { id: number }, TContext>({
    mutationFn: ({ id }) => deleteEstimate(id),
    ...mutationOptions,
  });
};
